import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useTheme } from '../hooks/useTheme.js';
import { TableProvider } from './TableProvider.js';

var Table = forwardRef(function Table(_a, ref) {
    var columnsTemplate = _a.columnsTemplate, _b = _a.themeKey, themeKey = _b === void 0 ? "table" : _b, _c = _a.backgroundColor, backgroundColor = _c === void 0 ? "white" : _c, props = __rest(_a, ["columnsTemplate", "themeKey", "backgroundColor"]);
    var context = {
        state: { columnsTemplate: columnsTemplate },
    };
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps(props, {
        themeKey: themeKey,
        baseStyle: {
            display: "block",
            width: "100%",
            backgroundColor: backgroundColor,
        },
    });
    return (jsx(TableProvider, __assign({ value: context }, { children: jsx("table", __assign({ "data-table": true, ref: ref }, forwardProps)) })));
});

export { Table };
//# sourceMappingURL=Table.js.map
